"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
require("select2");
exports.default = vue_1.default.extend({
    name: "HeSelect2",
    inheritAttrs: false,
    model: {
        event: "change",
        prop: "value",
    },
    props: {
        options: {
            type: Array,
            default: [],
        },
        multiple: {
            type: Boolean,
            default: true,
        },
        settings: {
            type: Object,
            default: function () {
            },
        },
        value: null,
    },
    watch: {
        options: function (val) {
            this.setOption(val);
        },
        value: function (nv) {
            this.setValue(nv);
        },
    },
    methods: {
        setOption: function (val) {
            if (val === void 0) { val = []; }
            var $el = $(this.$el);
            $el.empty();
            if (val.length > 0) {
                for (var _i = 0, val_1 = val; _i < val_1.length; _i++) {
                    var o = val_1[_i];
                    $el.append(new Option(o.text, o.id, false, false));
                }
            }
            $el.trigger("change.select2");
        },
        setValue: function (val) {
            var fixedVal = [];
            if (val == null) {
                fixedVal = [];
            }
            else if (val instanceof Array) {
                fixedVal = val;
            }
            else {
                fixedVal = [val];
            }
            $(this.$el).val(fixedVal)
                .trigger("change.select2");
        },
    },
    mounted: function () {
        var _this = this;
        $(this.$el)
            .select2(__assign({}, this.settings, { data: this.options }))
            .on("change", function () {
            var $el = $(_this.$el), val = $el.val();
            _this.$emit("change", val, $el);
        });
        this.setValue(this.value);
    },
    beforeDestroy: function () {
        $(this.$el).select2("destroy");
    },
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/SharedComponent/HeSelect2/HeSelect2.vue
// module id = 223
// module chunks = 0